import _get from "lodash/get";
import { css } from 'styled-components';
import { rem } from 'polished';
import typographyTheme from './typographyTheme';

var listStyles = function listStyles() {
  return css(["font-family:", ";font-size:", ";margin-bottom:", ";padding-left:", ";"], function (_ref) {
    var theme = _ref.theme;
    return _get(theme, 'typography.base.fontFamily', typographyTheme.typography.base.fontFamily);
  }, function (_ref2) {
    var theme = _ref2.theme;
    return rem(_get(theme, 'typography.base.fontSize', typographyTheme.typography.base.fontSize));
  }, rem(16), rem(16));
};

export default listStyles;